import React from 'react';
import { View } from '@shared/components/View';
import { MBChatDateMarker } from './dateMarker';
import { MBChatReadMarker } from './readMarker';

interface MBMessageWithMarkersWrapperProps {
  layout?: MBChatMessageLayoutOptions;
  message: MBAPI.ChatMessage;
  children: React.ReactNode;
}

/*
    HOC-ish to wrap a chat message with different external layout decorators. Eg read markers,
    date markers. These are simply additions before/after any message.
*/
export function MBMessageWithMarkersWrapper({
  layout,
  message,
  children,
}: MBMessageWithMarkersWrapperProps) {
  return (
    <View testID="chat-message" data-message-id={message.id}>
      {!!layout && layout.isReadMarkerVisible && <MBChatReadMarker />}
      {!!layout && layout.isDateMarkerVisible && <MBChatDateMarker date={message.createdAt} />}
      {children}
    </View>
  );
}
